import React from "react";
import "./cardAssociation.scss";

import { Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const CardAssociation = ({
  width = "100%",
  height = "100%",
  disabledSelection,
  name,
  image,
  idAssociation,
  setSelected,
  selected,
  link = false,
}) => {
  const navigate = useNavigate();
  const handleSelect = (item) => {
    if (!disabledSelection) {
      setSelected((prev) => {
        const next = prev.includes(item)
          ? prev.filter((i) => i !== item)
          : [...prev, item];
        return next;
      });
    }
  };

  return (
    <Stack
      direction="horizontal"
      gap={3}
      className="p-2 d-flex justify-content-start align-items-center card-association"
      style={{
        width,
        height,
        ...(disabledSelection
          ? {}
          : selected?.includes(idAssociation)
          ? { border: "solid 2px #608ABD" }
          : {}),
      }}
      onClick={() =>
        disabledSelection
          ? link
            ? navigate(link)
            : null
          : handleSelect(idAssociation)
      }
    >
      <img src={image} />
      <span>{name}</span>
    </Stack>
  );
};

export default CardAssociation;
